export default "https://cdn-static.gokick.com/assets/0f3104c02f0c7e58561d070a1e1ba5e916429e4c/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";